import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab} from '@material-ui/core'



 

export default class AlertDialog extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                 open={this.props.open}
                 onClose={this.props.dialogClose}
                 style={{zIndex:6000}}
                 >
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>
                 <DialogActions className="pm-dialog-bottom-buttons">
                          
                          <Button  variant="outlined" onClick={this.props.yesFunction} className='pm-save-button'>
                                      {this.props.noButtonDisplay === 1 ? this.props.limba.comune.ok    : this.props.limba.comune.yes}
                          </Button>

                           <Button style={{display:this.props.noButtonDisplay === 1 ? 'none' : 'inline-flex'}} variant="outlined" onClick={this.props.dialogClose} className='pm-delete-button'>
                                      {this.props.limba.comune.no}
                          </Button>
                          
                       
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}